import React from 'react';
import Heading from '@hubins/components/Heading';
import './MenuTitle.scss';

export const MenuTitle = (props) => (
  <Heading element="h3" size="4" className={`menu__title ${props.className}`}>{props.title}</Heading>
);

export default MenuTitle;
